import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ThankYouMessage = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Thank You for Joining Team Agua Rotterdam!',
      subtitle: 'Welcome to the Team',
      message: 'Congratulations on taking the first step in your Brazilian Jiu-Jitsu journey! Your membership has been successfully activated.',
    },
    nl: {
      title: 'Bedankt voor je aanmelding bij Team Agua Rotterdam!',
      subtitle: 'Welkom bij het Team',
      message: 'Gefeliciteerd met het zetten van de eerste stap in je Brazilian Jiu-Jitsu reis! Je lidmaatschap is succesvol geactiveerd.',
    },
  };

  const text = content[language] || content.en;

  return (
    <div className="thank-you-message">
      <div className="success-icon">✓</div>
      <h1 className="thank-you-title">{text.title}</h1>
      <h2 className="thank-you-subtitle">{text.subtitle}</h2>
      <p className="thank-you-text">{text.message}</p>
    </div>
  );
};

export default ThankYouMessage;
